import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { RadioButtonGroup } from 'common-components'
import { editPensionAgeBumnanSmart } from 'quick-quote/product-common/coverage-plan/actions'
import { getActivePensionAgePlan, getAvaliablePensionAgePlan } from '../selectors'
import MESSAGES from 'core/data-model/constants/messages'

export const BumnanSmartPensionAgeSelection = ({
  getActivePensionAgePlan,
  getAvaliablePensionAgePlan,
  selectPensionAge,
}) => {
  const pensionAgeOptionPlan = [
    {
      text: '55 ปี',
      value: 55,
      canSelectable: getAvaliablePensionAgePlan.includes(55),
    },
    {
      text: '60 ปี',
      value: 60,
      canSelectable: getAvaliablePensionAgePlan.includes(60),
    },
    {
      text: '65 ปี',
      value: 65,
      canSelectable: getAvaliablePensionAgePlan.includes(65),
    },
    {
      text: '70 ปี',
      value: 70,
      canSelectable: getAvaliablePensionAgePlan.includes(70),
    },
  ]

  return (
    <div className="form-group">
      <div className="form-group-title">
        <span className="form-group-title-text">เลือกอายุรับบำนาญ</span>
      </div>
      <RadioButtonGroup
        keyToGetValue="value"
        className="model-factor"
        onChange={selectPensionAge}
        value={getActivePensionAgePlan}
        options={pensionAgeOptionPlan}
      />
      {Array.isArray(getAvaliablePensionAgePlan) && getAvaliablePensionAgePlan.length < 4 && (
        <div className="info-message attached-icon form-control-feedback" style={{ marginTop: '0px' }}>
          <p>{MESSAGES.PENSION_AGE_SELECTION_INFO_MESSAGE}</p>
        </div>
      )}
    </div>
  )
}

const mapStateToProps = (state) => ({
  getActivePensionAgePlan: getActivePensionAgePlan(state),
  getAvaliablePensionAgePlan: getAvaliablePensionAgePlan(state),
})

const mapDispatchToProps = (dispatch) => ({
  selectPensionAge: bindActionCreators(editPensionAgeBumnanSmart, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(BumnanSmartPensionAgeSelection)
